// Module
var code = "<div class=\"modal fade\" id=\"approvaAllModal\"> <wt-modal yes-function=\"vm.approveAll()\" modal-title=\"{{vm.title|translate}}\"> <span>{{vm.message|translate}}</span> </wt-modal> </div>";
// Exports
module.exports = code;